import Checkbox from '@mui/material/Checkbox'
import * as React from 'react'
import { memo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ContentItem } from 'interfaces'
import { addContentToSelection, removeContentFromSelection } from 'services/content'
import { selectedContentItemsSelector } from 'services/content/selectors'
import StoreState, { StoreThunkDispatch } from 'store/state'

import styles from './ContentCard.pcss'

interface ContentCardSelectProps {
  content: ContentItem
  // EXPL: The card resolves live article data, so the item put into the selection is not always `content`.
  getSelectableContent(): ContentItem
}

function stopPropagation(e: React.MouseEvent) {
  e.stopPropagation()
}

/**
 * The select checkbox, subscribed to the store on its own.
 *
 * EXPL: Kept out of ContentCard so that toggling one card's selection - which replaces the whole
 * `items` map - re-renders only the checkboxes, not every card body in the grid.
 */
export function ContentCardSelect({ content, getSelectableContent }: ContentCardSelectProps) {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const checked = useSelector((state: StoreState) => Boolean(selectedContentItemsSelector(state)[content.id]))

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      dispatch(addContentToSelection([getSelectableContent() as any]))
    } else {
      dispatch(removeContentFromSelection([content.id]))
    }
  }, [dispatch, content.id, getSelectableContent])

  return (
    <div className={styles.cbBox} onClick={stopPropagation}>
      <Checkbox
        size="small"
        checked={checked}
        classes={{ root: styles.cb }}
        onChange={onChange}
      />
    </div>
  )
}

export default memo(ContentCardSelect)
